import { render } from "./DaftarFinance.vue?vue&type=template&id=10affa6a"
import script from "./DaftarFinance.vue?vue&type=script&lang=js"
export * from "./DaftarFinance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__